import permissions from '../../permissions'

const INTEGRATION_PARTNER_PLAN_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.INTEGRATION_PARTNER_PLANS.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.EDIT,
    tag: permissions.INTEGRATION_PARTNER_PLANS.UPDATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.INTEGRATION_PARTNER_PLANS.DESTROY,
  },
]

export default INTEGRATION_PARTNER_PLAN_LIST
